import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { isProductionOrStaging } from "@/lib/environment";
import { useTagLoaderReady } from "./useTagLoaderReady";
export function GtmScripts() {
  const $ = _c(6);
  const loadTags = useTagLoaderReady();
  if (!isProductionOrStaging() || !process.env.NEXT_PUBLIC_GTM_ID) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="gtm-init" strategy="afterInteractive">{"window.posthog = window.posthog || { __SV: 1, init: function(){} };\nwindow.dataLayer = window.dataLayer || [];\nif (typeof window.gtag !== 'function') { window.gtag = function(){window.dataLayer.push(arguments);} }\nwindow.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});"}</Script>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== loadTags) {
    t1 = loadTags && <Script id="gtm-script" strategy="afterInteractive" src={`https://www.googletagmanager.com/gtm.js?id=${process.env.NEXT_PUBLIC_GTM_ID}`} />;
    $[1] = loadTags;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Script id="gtm-strip-gl" strategy="afterInteractive">{"(function() {\n  function stripGl(a) {\n    try {\n      var u = new URL(a.href);\n      if (u.searchParams.has('_gl')) {\n        u.searchParams.delete('_gl');\n        a.href = u.toString();\n      }\n    } catch(e) {}\n  }\n  new MutationObserver(function(mutations) {\n    for (var i = 0; i < mutations.length; i++) {\n      var el = mutations[i].target;\n      if (el.nodeName === 'A') stripGl(el);\n    }\n  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['href'] });\n  document.addEventListener('mousedown', function(e) {\n    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;\n    if (a) setTimeout(function() { stripGl(a); }, 0);\n  }, true);\n})();"}</Script>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <>{t0}{t1}{t2}</>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}